import styled from 'styled-components';

export const SyledEstimation = styled.div`
  /* ── Reset ── */
  span {
    display: block;
  }
  .mb-5 {
    margin-bottom: 5px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mt-2 {
    margin-top: 8px;
  }
  .mt-3 {
    margin-top: 16px;
  }
  .mr-2 {
    margin-right: 8px;
  }
  .w-100 {
    width: 100%;
  }
  .d-flex {
    display: flex;
  }
  .align-items-center {
    align-items: center;
  }
  .justify-content-center {
    justify-content: center;
  }
  .justify-content-between {
    justify-content: space-between;
  }
  .gap-2 {
    gap: 8px;
  }
  .gap-3 {
    gap: 12px;
  }

  .text-dark {
    color: #1a1f36;
  }
  .text-muted {
    color: #6b7280;
  }
  .text-success {
    color: #15803d;
  }
  .text-danger {
    color: #dc2626;
  }
  .font-weight-bold {
    font-weight: 700;
  }
  .font-weight-normal {
    font-weight: 400;
  }

  textarea {
    resize: none;
  }

  .label-text {
    display: block;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: #4b5563;
    margin-bottom: 6px;
  }

  /* ── Top Header Bar ── */
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #2a3f8f, #3b5bdb);
    padding: 14px 24px;
    border-radius: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 12px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-wrap: wrap;

      .job-id-label {
        font-size: 16px;
        font-weight: 700;
        color: #fff;
      }

      .status-badge {
        background: rgba(255, 255, 255, 0.2);
        color: #fff;
        padding: 4px 14px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  /* ── Section Card ── */
  .section-card {
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 20px;
    position: relative;

    .section-title {
      font-size: 16px;
      font-weight: 700;
      color: #1a1f36;
      margin: 0 0 4px;

      &.vendor-notes-title {
        display: flex;
        margin: 0 0 10px;
      }

      .optional-text {
        font-size: 14px;
        font-weight: 400;
        color: #9ca3af;
      }
    }

    .section-subtitle {
      font-size: 13px;
      color: #6b7280;
      margin-bottom: 16px;
    }

    .section-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      flex-wrap: wrap;
      gap: 10px;

      .section-header-left {
        .section-title {
          margin-bottom: 4px;
        }
      }

      .section-header-right {
        display: flex;
        gap: 10px;
      }
    }
  }

  .address-holder {
    position: relative;

    .btn-remove-address {
      position: absolute;
      top: 0;
      right: 0;
      color: var(--danger);
      cursor: pointer;
    }
  }

  /* ── Estimate Items ── */
  .items-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .item-card {
    display: flex;
    flex-direction: column;
    gap: 20px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    .item-number {
      position: absolute;
      top: 12px;
      left: 12px;
      width: 24px;
      height: 24px;
      background: #f3f4f6;
      border: 1px solid #d1d5db;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 700;
      font-size: 11px;
      color: #374151;
    }

    .item-image-placeholder {
      background: #f9fafb;
      border: 1px dashed #d1d5db;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d1d5db;
    }

    .item-header-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .item-name-input {
        font-size: 18px;
        font-weight: 700;
        color: #1a1f36;
        border: none;
        background: transparent;
        border-bottom: 1px dashed #d1d5db;
        padding: 4px 0;
        width: 400px;
        outline: none;
        &:focus {
          border-bottom-color: #3b5bdb;
        }
      }
    }

    .item-details-col {
      width: 100%;
    }

    .item-input-col {
      width: 100%;
      border-top: 1px solid #f3f4f6;
      padding-top: 24px;
      overflow-x: auto;

      .tables-grid {
        display: flex;
        gap: 20px;
        width: 100%;
        @media (max-width: 992px) {
          flex-direction: column;
        }

        & > div:first-child {
          flex: 0 0 35%;
          min-width: 0;
        }

        & > div:last-child {
          flex: 0 0 calc(65% - 20px);
          min-width: 0;
        }
      }
    }

    .item-summary-footer {
      width: 100%;
      border-top: 2px solid #eef2ff;
      padding-top: 24px;
    }

    .vendor-margin-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 40px;
      @media (max-width: 992px) {
        grid-template-columns: 1fr;
      }
    }

    .item-margin-controls {
      width: 100%;
      .margin-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        .label {
          font-size: 14px;
          font-weight: 600;
          color: #475569;
        }
        .value {
          color: #3b5bdb;
          font-weight: 700;
          font-size: 16px;
        }
      }
      .slider-wrapper {
        display: flex;
        align-items: center;
        gap: 16px;
        width: 100%;
        span {
          font-size: 12px;
          color: #94a3b8;
          font-weight: 600;
          min-width: 40px;
        }
        input[type='range'] {
          flex: 1;
          height: 6px;
          accent-color: #3b5bdb;
          cursor: pointer;
        }
      }
    }
  }

  /* ── Tables ── */
  .card-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #eef2ff;
    border-radius: 8px;
    overflow: hidden;

    th,
    td {
      padding: 10px 8px;
      text-align: left;
      border-bottom: 1px solid #f1f5f9;
      border-right: 1px solid #f1f5f9;
      font-size: 13px;
    }
    th:last-child,
    td:last-child {
      border-right: none;
    }
    tr:last-child td {
      border-bottom: none;
    }

    th {
      background: #f8faff;
      color: #6b7280;
      font-weight: 600;
      text-transform: uppercase;
      font-size: 11px;
      letter-spacing: 0.4px;
      &.text-center {
        text-align: center;
      }

      &.pk-header {
        background: #ecfdf5 !important;
        color: #065f46 !important;
        border-bottom: none;
      }
      &.cn-header {
        background: #fef2f2 !important;
        color: #991b1b !important;
        border-bottom: none;
      }
      &.calc-header {
        background: #eef2ff !important;
        color: #3730a3 !important;
        border-bottom: none;
      }
    }

    .tier-cell {
      background: #f8faff;
      font-weight: 600;
      width: 100px;
      .weight-tag {
        display: inline-block;
        font-size: 10px;
        background: #e0f2fe;
        color: #0369a1;
        padding: 2px 6px;
        border-radius: 4px;
        margin-top: 4px;
        white-space: nowrap; /* Prevent weight from wrapping */
      }
    }

    .input-cell {
      &.rate-input-cell {
        width: 80px;
      } /* Small rate input */
    }
    .method-cell {
      width: 160px; /* Large method select */
    }
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 24px;
    background: #f8faff;
    padding: 24px;
    border-radius: 12px;
    @media (max-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    }

    .summary-item {
      display: flex;
      flex-direction: column;
      gap: 6px;
      .label {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.05em;
      }
      .val {
        font-size: 16px;
        font-weight: 800;
        color: #1e293b;
      }

      &.final {
        .label {
          color: #065f46;
        }
        .val {
          color: #15803d;
          font-size: 20px;
        }
      }
    }
  }

  .summary-cards-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .summary-vendor-header {
    grid-column: 1 / -1;
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e2e8f0;
    margin-bottom: 8px;
    span {
      font-size: 14px;
      font-weight: 700;
      color: #1e293b;
      text-transform: uppercase;
      letter-spacing: 0.05em;
    }
  }

  /* ── Comparison Table ── */
  .comparison-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid #e8ecf1;
    border-radius: 12px;
    overflow: hidden;
    font-size: 13px;

    th,
    td {
      padding: 12px 16px;
      text-align: center;
      border-bottom: 1px solid #f0f2f5;
      border-right: 1px solid #f0f2f5;
    }
    th:last-child,
    td:last-child {
      border-right: none;
    }
    tr:last-child td {
      border-bottom: none;
    }

    th {
      background: #f8faff;
      font-weight: 700;
      color: #64748b;
      font-size: 10px;
      text-transform: uppercase;
      letter-spacing: 0.05em;

      &.pk-header {
        background: #ecfdf5 !important;
        color: #065f46 !important;
      }
      &.cn-header {
        background: #fef2f2 !important;
        color: #991b1b !important;
      }
      &.calc-header {
        background: #eef2ff !important;
        color: #3730a3 !important;
      }
    }

    td:first-child {
      text-align: left;
      font-weight: 700;
      background: #f8faff;
      color: #1e293b;
    }
  }

  /* ── Inputs & Selects ── */
  .cost-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    font-size: 13px;
    &:focus {
      outline: none;
      border-color: #3b5bdb;
      box-shadow: 0 0 0 3px rgba(59, 91, 219, 0.1);
    }
  }

  select {
    width: 100%;
    padding: 4px 8px; /* Reduced height to match input */
    height: 32px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    background: #fff;
    font-size: 13px;
  }

  .btn-add {
    font-size: 14px;
    line-height: 18px;
    padding: 2px 6px;
    border: 1px solid var(--primary);
    border-radius: 5px;
  }

  .currency-input-wrapper {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 100px;
    margin: 0 auto;

    input {
      flex: 1;
      text-align: right;
      border: none;
      background: transparent;
      outline: none;
      padding: 2px 4px;
      /* font-weight: 600; */
      width: 50px;
    }
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 0 4px;
    background: #fff;
    min-width: 0;
    &:focus-within {
      border-color: #3b5bdb;
    }

    &.rate-input-cell {
      width: 80px;
    }
  }

  .card-vendor-select {
    display: flex;
    gap: 8px;
    .vendor-opt {
      flex: 1;
      padding: 10px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        background: #f9fafb;
      }
      &.active {
        &.pk {
          background: #ecfdf5;
          border-color: #10b981;
          color: #065f46;
        }
        &.cn {
          background: #fef2f2;
          border-color: #ef4444;
          color: #991b1b;
        }
        &.calc {
          background: #eef2ff;
          border-color: #6366f1;
          color: #3730a3;
        }
      }
    }
  }

  .tiers-selection-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;
  }

  .tier-checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13px;
    color: #4b5563;
    background: #f9fafb;
    padding: 6px 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    transition: all 0.2s;
    &:hover {
      background: #f3f4f6;
    }
    input[type='checkbox'] {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  .btn-finalize {
    background: linear-gradient(135deg, #2a3f8f, #3b5bdb);
    color: #fff;
    border: none;
    padding: 10px 24px;
    border-radius: 8px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }

  .btn-finalize-large {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin-left: auto;
  }
`;
